export default __webpack_public_path__ + "static/media/volume-muted.29dd5241.svg";